import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9034954e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-self-signature" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h1", null, [
    _createTextVNode(_toDisplayString(_ctx.title === "对方正在输入" ? _ctx.$t("TUIChat.对方正在输入") : _ctx.title) + " ", 1),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.selfSignature), 1)
  ]))
}